/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Select_ProductsInputs */

const en_admin_resource_form_select_products = /** @type {(inputs: Admin_Resource_Form_Select_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select products to offer with this resource`)
};

const de_admin_resource_form_select_products = /** @type {(inputs: Admin_Resource_Form_Select_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle aus, welche Produkte und Services Besucher hinzufügen können, wenn sie diese Ressource buchen. Derzeit nur für öffentliche Ressourcen verfügbar.`)
};

const es_admin_resource_form_select_products = /** @type {(inputs: Admin_Resource_Form_Select_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona qué productos y servicios pueden añadir tus visitantes al reservar este recurso. Actualmente solo está disponible para recursos públicos.`)
};

const fr_admin_resource_form_select_products = /** @type {(inputs: Admin_Resource_Form_Select_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez les produits et services que les visiteurs peuvent acheter lorsqu'ils réservent cette ressource. Actuellement disponible uniquement pour les ressources publiques.`)
};

/** @type {(inputs: Admin_Resource_Form_Select_ProductsInputs) => LocalizedString} */
const it_admin_resource_form_select_products = en_admin_resource_form_select_products;

/** @type {(inputs: Admin_Resource_Form_Select_ProductsInputs) => LocalizedString} */
const pt_br2_admin_resource_form_select_products = en_admin_resource_form_select_products;

/** @type {(inputs: Admin_Resource_Form_Select_ProductsInputs) => LocalizedString} */
const pl_admin_resource_form_select_products = en_admin_resource_form_select_products;

/** @type {(inputs: Admin_Resource_Form_Select_ProductsInputs) => LocalizedString} */
const hu_admin_resource_form_select_products = en_admin_resource_form_select_products;

/** @type {(inputs: Admin_Resource_Form_Select_ProductsInputs) => LocalizedString} */
const ro_admin_resource_form_select_products = en_admin_resource_form_select_products;

/**
* | output |
* | --- |
* | "Select products to offer with this resource" |
*
* @param {Admin_Resource_Form_Select_ProductsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_select_products = /** @type {((inputs?: Admin_Resource_Form_Select_ProductsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Select_ProductsInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_select_products(inputs)
	if (locale === "de") return de_admin_resource_form_select_products(inputs)
	if (locale === "es") return es_admin_resource_form_select_products(inputs)
	if (locale === "fr") return fr_admin_resource_form_select_products(inputs)
	if (locale === "it") return it_admin_resource_form_select_products(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_select_products(inputs)
	if (locale === "pl") return pl_admin_resource_form_select_products(inputs)
	if (locale === "hu") return hu_admin_resource_form_select_products(inputs)
	return ro_admin_resource_form_select_products(inputs)
});
export { admin_resource_form_select_products as "admin.resource_form.select_products" }